/* eslint-disable max-lines */
import { EGDSCard, EGDSCardContentSection } from '@egds/react-core/cards';
import { EGDSFigureAspectRatioType } from '@egds/react-core/images';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import { EGDSLayoutGrid, EGDSLayoutGridItem } from '@egds/react-core/layout-grid';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { Layer } from 'bernie-view';
import { QueryRoute, updateSearch } from 'bernie-core';
import { PropertyInventorySource, PropertyInventorySourceSplitted, PropertySpaceOverview, PropertySpaceOverviewSplitted, PropertySummaryAmenities, PropertySummaryAmenitiesSplitted, PropertySummaryHeader, PropertySummaryHeaderSplitted, PropertySummaryMapTrigger, PropertySummaryMapTriggerSplitted, PropertySummaryNearByPois, PropertySummaryNearByPoisSplitted, PropertySummaryReviews, PropertySummaryReviewsSplitted } from '@shared-ui/lodging-property-details';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { IdentifierType, RelevantContent } from '@shared-ui/retail-product-relevant-content';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { SharedUiMap } from 'components/infosite/shared-ui/details/map-wrapper';
import { SharedUiPropertyReviewsDialog } from 'components/infosite/shared-ui/reviews/shared-ui-property-reviews-dialog';
import { withSharedUiPropertyDetails } from 'components/infosite/shared-ui/details/shared-ui-property-details';
import { usePropertyDetailsQueryCSRExperiment } from '../shared-ui/details/use-property-details-query';
const SummaryWrapper = React.memo(({
  inputs
}) => {
  const history = useHistory();
  const location = useLocation();
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  const onClickMap = React.useCallback(() => updateSearch({
    history,
    location,
    newParams: {
      pwaDialog: 'map'
    }
  }), [history, location]);
  const onClickReviews = React.useCallback(() => updateSearch({
    history,
    location,
    newParams: {
      pwaDialog: 'reviews'
    }
  }), [history, location]);
  const relevantContentVariants = skipSsrRendering => React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'six'
    }
  }, React.createElement("div", null, React.createElement(RelevantContent, {
    inputs: {
      productIdentifier: {
        id: inputs.propertyId,
        type: IdentifierType.PROPERTY_ID,
        travelSearchCriteria: {
          property: inputs.searchCriteria
        }
      }
    },
    skipSsr: skipSsrRendering
  }))));
  const RelevantContentWrapper = () => React.createElement(Experiment, {
    name: "Filter_ranking_model_for_amenity_module_Web"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, relevantContentVariants(false)), React.createElement(ExperimentVariant, {
    bucket: 2
  }, relevantContentVariants(true)));
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'six',
      blockstart: 'half'
    }
  }, React.createElement(EGDSCard, {
    className: "custom-css-flat-border-top"
  }, React.createElement(EGDSCardContentSection, null, React.createElement(EGDSSpacing, {
    padding: {
      large: {
        inline: 'three',
        block: 'three'
      }
    }
  }, React.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, React.createElement(React.Fragment, null, React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'four'
    }
  }, React.createElement("div", {
    "data-stid": "content-hotel-title"
  }, React.createElement(PropertySummaryHeader, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'six'
    }
  }, React.createElement(PropertySummaryReviews, {
    inputs: inputs,
    onClickReviews: onClickReviews,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, null, React.createElement(PropertySpaceOverview, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'four'
    }
  }, React.createElement("div", null, React.createElement(PropertyInventorySource, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'six'
    },
    margin: {
      block: 'three'
    }
  }, React.createElement(PropertySummaryAmenities, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(RelevantContentWrapper, null), React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(EGDSSpacing, {
    padding: {
      small: {
        blockend: 'six'
      }
    }
  }, React.createElement(PropertySummaryMapTrigger, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(EGDSSpacing, {
    padding: {
      small: {
        blockend: 'six'
      }
    }
  }, React.createElement(PropertySummaryNearByPois, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ViewMedium, null, React.createElement(EGDSLayoutGrid, {
    space: "three",
    columns: 2
  }, React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(PropertySummaryMapTrigger, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(PropertySummaryNearByPois, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ViewLarge, null, React.createElement(EGDSLayoutGrid, {
    space: "three",
    columns: 2
  }, React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(PropertySummaryMapTrigger, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(Experiment, {
    name: "PEXO_PDP_Location_summary_layout_improvement"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertySummaryNearByPois, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'eight'
    }
  }, React.createElement(PropertySummaryNearByPois, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))))))))))))), React.createElement(MapDialogWrapper, null), React.createElement(SharedUiPropertyReviewsDialog, {
    dialogType: "reviews"
  })))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockend: 'six',
      blockstart: 'half'
    }
  }, React.createElement(EGDSCard, {
    className: "custom-css-flat-border-top"
  }, React.createElement(EGDSCardContentSection, null, React.createElement(EGDSSpacing, {
    padding: {
      large: {
        inline: 'three',
        block: 'three'
      }
    }
  }, React.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, React.createElement(React.Fragment, null, React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'four'
    }
  }, React.createElement("div", {
    "data-stid": "content-hotel-title"
  }, React.createElement(PropertySummaryHeaderSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'six'
    }
  }, React.createElement(PropertySummaryReviewsSplitted, {
    inputs: inputs,
    onClickReviews: onClickReviews,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, null, React.createElement(PropertySpaceOverviewSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'four'
    }
  }, React.createElement("div", null, React.createElement(PropertyInventorySourceSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(EGDSLayoutFlexItem, null, React.createElement(EGDSSpacing, {
    padding: {
      blockend: 'six'
    },
    margin: {
      block: 'three'
    }
  }, React.createElement(PropertySummaryAmenitiesSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(RelevantContentWrapper, null), React.createElement(EGDSLayoutFlexItem, null, React.createElement("div", null, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(React.Fragment, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(EGDSSpacing, {
    padding: {
      small: {
        blockend: 'six'
      }
    }
  }, React.createElement(PropertySummaryMapTriggerSplitted, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(EGDSSpacing, {
    padding: {
      small: {
        blockend: 'six'
      }
    }
  }, React.createElement(PropertySummaryNearByPoisSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ViewMedium, null, React.createElement(EGDSLayoutGrid, {
    space: "three",
    columns: 2
  }, React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(PropertySummaryMapTriggerSplitted, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(PropertySummaryNearByPoisSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))), React.createElement(ViewLarge, null, React.createElement(EGDSLayoutGrid, {
    space: "three",
    columns: 2
  }, React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "map-image-link"
  }, React.createElement(PropertySummaryMapTriggerSplitted, {
    inputs: inputs,
    onClickMap: onClickMap,
    aspectRatio: EGDSFigureAspectRatioType.R21_9,
    skipSsr: cSRPropertyDetailsQuery
  }))), React.createElement(EGDSLayoutGridItem, null, React.createElement("div", {
    "data-stid": "location-summary"
  }, React.createElement(Experiment, {
    name: "PEXO_PDP_Location_summary_layout_improvement"
  }, React.createElement(ExperimentControl, null, React.createElement(PropertySummaryNearByPoisSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'eight'
    }
  }, React.createElement(PropertySummaryNearByPoisSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  }))))))))))))))), React.createElement(MapDialogWrapper, null), React.createElement(SharedUiPropertyReviewsDialog, {
    dialogType: "reviews"
  })))));
});
const MapDialogWrapper = () => {
  const history = useHistory();
  const onCloseDialog = React.useCallback(() => history.goBack(), [history]);
  return React.createElement(QueryRoute, {
    query: {
      pwaDialog: 'map'
    }
  }, React.createElement(Layer, {
    id: "infosite-map",
    onDismiss: onCloseDialog
  }, React.createElement(SharedUiMap, {
    onClose: onCloseDialog
  })));
};
MapDialogWrapper.displayName = 'MapDialogWrapper';
export const SingleOfferSummaryWrapper = withSharedUiPropertyDetails(SummaryWrapper);
SingleOfferSummaryWrapper.displayName = 'SingleOfferSummaryWrapper';